import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { WEBSITE_URL } from '../../../auth/config/constants';
import { AuthService } from '../../../auth/services/auth.service';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnInit {
  visibility: boolean = false;
  type: string = 'info';
  message: string = '';
  close: boolean | undefined = false;
  className: string | undefined = '';

  constructor(
    private readonly alertService: AlertService,
    private readonly authService: AuthService
  ) {}
  ngOnInit(): void {
    this.alertService.getAlert().subscribe(alert => {
      this.message = alert.message;
      this.type = alert.type;
      this.visibility = alert.visible;
      this.close = alert.close;
      this.className = alert.className;
      if (
        this.className === 'tenant-payment-alert' ||
        this.className === 'tenant-payment-purchase-alert' ||
        this.className === 'tenant-payment-renew-alert'
      ) {
        document.body.classList.add('payment-required');
      }

      if (
        this.className !== 'channel-alert' &&
        this.className !== 'dnc-import-alert' &&
        this.className !== 'tenant-payment-alert' &&
        this.className !== 'tenant-payment-purchase-alert' &&
        this.className !== 'tenant-payment-renew-alert' &&
        this.className !== 'sip-alert'
      ) {
        this.setAlertTimer();
      }
    });
  }

  setAlertTimer(): void {
    setTimeout(() => (this.visibility = false), 5000);
  }

  closeAlert(): void {
    this.visibility = false;
    this.close = false;
  }

  continueAlert() {
    this.alertService.emitAlertChangeEvent(true);
  }

  keepAlert() {
    this.alertService.emitAlertChangeEvent(false);
  }

  acceptAlert() {
    this.alertService.emitAlertChangeEvent('accept');
  }

  navigateToWebsite() {
    this.logOutUserFromAlert();
    window.open(WEBSITE_URL.WEBSITE_PRICING, '_blank');
  }

  logOutUserFromAlert() {
    this.closeAlert();
    this.authService.logoutEvent.emit('User triggered Logout from Alert');
  }
}
